abstract class BaseWorkflowStep<T> {
    public readonly stepEnum: T; // enum for mapping

    public constructor(step: T) {
        this.stepEnum = step;
    }

    public abstract isValid(): boolean; // Condition for the step to occur
    public abstract isCompleted(): boolean; // Condition for the step to be completed
}

export { BaseWorkflowStep };
